export default "__VITE_ASSET__SkxpPKu___"